import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import useFocusOnRouteChange from "@/hooks/useFocusOnRouteChange";
import { validateItemName } from "@/utilities/Validation";
import { Field, useFormikContext } from "formik";
import { useRef, type FC } from "react";
import EntityHierarchy from "../entityHierarchy/entityHierarchy";
import Label from "../label/label";
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';
import { ListQuery } from "@/models/ListQuery";
import { getReaderNamesWithPagination } from "@/services/readerService";


const LiftCard: FC = () => {
    const { errors, values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const inputRef = useRef<HTMLInputElement>(null);
    useFocusOnRouteChange(inputRef);

    return <div className="w-full p-2 inline-flex justify-start items-center bg-white">
        {values.id ?
            (<div className="ml-8 mr-5 card-details">
                <EntityHierarchy title={values.name} tree={{ label: values.site, node: { label: values.name } }} />
            </div>) : ""}
        <div className="flex flex-col">
            <div className="flex flex-col  py-1">
                <div className="flex flex-row justify-between" id="nameLabel">
                    <Label
                        htmlFor="name"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                    {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                </div>
                <Field
                    type="text"
                    name="name"
                    innerRef={inputRef}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input" id="nameInput"
                    validate={(value) => validateItemName(value, translate)} />
            </div>
            <div className="flex flex-col  py-1">
                <div className="flex flex-row justify-between" id="siteLabel">
                    <Label
                        htmlFor="siteId"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.site)}:</Label>
                </div>
                <Field
                    value={values.site}
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
        </div>
        <div className="flex flex-col">
            <div className="flex flex-col px-4 py-1">
                <div className="flex flex-row justify-between" id="buildingLabel">
                    <Label
                        htmlFor="buildingId"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.building)}:</Label>
                </div>
                <Field
                    value={values.building}
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
            <div className="flex flex-col px-4 py-1">
                <div className="flex flex-row justify-between" id='readerLabelId'>
                    <Label
                        htmlFor="readerId"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.reader)}:</Label>
                    {errors.readerId ? <span className='text-red-600 text-xs'>{errors.readerId}</span> : null}
                </div>
                <PaginatedSearchableSelectField
                    name={translate.byKey(TranslationKeys.reader)}
                    key="readerId"
                    accessor='readerId'
                    dataMethod={(listParameters?: ListQuery) => getReaderNamesWithPagination({ ...listParameters, filters: listParameters?.filters }) }
                    searchAccessor={'devName'}
                    required={true}
                    onSelect={(_, item) => {
                        setFieldValue('reader', item?.label)
                        setFieldValue('readerId', item?.value)
                    }}
                    selectedItemLabel={values.readerName}
                    disabled={true} />
            </div>
        </div>
    </div>
};

export default LiftCard;